import { ActionIcon } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";

import { useDeleteUser } from "../../api/user";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";

export default function DeleteUserModal({ userId }) {
  const { mutate } = useDeleteUser(userId);
  const confirmDelete = useDeleteConfirm("user", mutate);

  return (
    <ActionIcon
      onClick={() => confirmDelete()}
      aria-label="Delete user"
      color="red"
      variant="light"
    >
      <IconTrash />
    </ActionIcon>
  );
}
